import React, { Suspense, useCallback, useEffect, useState } from 'react'
import AutomationsGrid from '../../../GridList/AutomationsGrid'
import CreateAutomation from './EditAutomations/CreateAutomation';
import Card from "../../../GridList/Card";
import CreateRule from './CreateRule/CreateRule';
import ScheduledAction from './EditAutomations/ScheduledAction';
import CreateSchedule from './EditAutomations/CreateSchedule';
import { getAdvRules, getHolidaysModesAPI, getInputRules, getSchedules, getSiteAccessRestrictions } from '../../../../Api Methods/Api';
import { useDispatch, useSelector } from 'react-redux';
import { Await } from 'react-router-dom';
import Oval from 'react-loading-icons/dist/esm/components/oval';

import classes from "./Automations.module.css"
import { VerifyHandler } from '../../../../store/auth-actions';
import CreateHolidayMode from './HolidayMode/CreateHolidayMode';
import CreateAccessRestriction from './CreateAccessRestriction/CreateAccessRestriction';
import useData from 'rsuite/esm/InputPicker/hooks/useData';
import { Dialog } from 'primereact/dialog';
import Lottie from 'lottie-react';
import { Button } from 'primereact/button';
import successAnim from '../../../../assets/animations/success.json'
import failAnim from '../../../../assets/animations/fail.json'

const Automations = ({ OutPutsPinNames, InputsPinNames, deviceData, firmware, siteType}) => {
    console.log(OutPutsPinNames)
    console.log(InputsPinNames)
    const numInput = deviceData.singleDeviceSettingData.numInput
    const smartLocks = deviceData.singleDeviceSettingData.iglooLocks;
    const [IFTTTRules, setIFTTTRules] = useState(null);
    const [advRules, setAdvRules] = useState(null);
    const [schedules, setSchedules] = useState(null);
    const [holidaymode, setHolidayMode] = useState(null);
    const [siteAccessRestrictions, setSiteAccessRestrictions] = useState(null);
    const dispatch = useDispatch();

    const [failMessage, setFailMessage] = useState("")

    const [successVisible, setSuccessVisible] = useState(false);
    const [failVisible, setFailVisible] = useState(false);

    let token = useSelector(state => state.auth.token);
    let client = useSelector(state => state.auth.client);
    let DeviceUUID = useSelector(state => state.auth.DeviceUUID);


    const apiData = {
        token,
        client
    }

    // fetchAutomations is called when an automation is Created, Edited or Deleted.
    const fetchAutomations = async () => {
        const getIFTTTRules = async () => {
            const responseData = await getInputRules(apiData, DeviceUUID)
         
            setIFTTTRules(responseData);
        }

        const GetAdvRules = async () => {
            const responseData = await getAdvRules(apiData, DeviceUUID, dispatch)
       
            if (responseData.success) {
                setAdvRules(responseData.data.rules)
                console.log(responseData.data.rules)
            } else {
                setAdvRules([])
            }
        }

        const getSchedulesAndReminders = async () => {
            const responseData = await getSchedules(apiData, DeviceUUID)
       
            setSchedules(responseData.data);
        }

        const getHolidaysMode = async ()  => {
            const responseData = await getHolidaysModesAPI(apiData, DeviceUUID)
     
            setHolidayMode(responseData);
        }

        const GetSiteAccessRestrictions = async () => {
            const responseData = await getSiteAccessRestrictions(DeviceUUID, apiData, dispatch)
            setSiteAccessRestrictions(responseData)
 
        }

        getIFTTTRules();
        GetAdvRules();
        getSchedulesAndReminders();
        getHolidaysMode();
        GetSiteAccessRestrictions();
    }

    // Fetch data on mount
    useEffect(() => {
        console.log("mounted")
        fetchAutomations();
    }, []);


    const [showAutomation, setShowAutomation] = useState(null);
    //user selects between creating a sheduledAction, reminder or a rule - 0,1 or 2
    const HandleSelectAutomation = (AutomationID) => {
        setShowAutomation(AutomationID);
    }

    //--------------------   first index is outputs, second index is inputs, third is device details--------------------------------
    const DeviceDataArray = Object.values(deviceData);

    let allListOptionsArray;

    if (numInput != 0) {
        allListOptionsArray = [...OutPutsPinNames, ...InputsPinNames];
    } else {
        allListOptionsArray = [...OutPutsPinNames];
    }

    //--------------------------------------------------------------------------------------------------------------------------------

    //use to pass the rule's pins that haven't been assigned to CreateRule component
    const [remainingrules, setRemainRules] = useState([]);

    const updateRemainRules = (rules) => {
        setRemainRules(rules)
    }

    useEffect(() => {
    }, [schedules])
    return (
        <>

        <Dialog
                header="Success"
                visible={successVisible}
                style={{ width: "40vw" }}
                onHide={() => setSuccessVisible(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Rule created successfully!</h3>
                        <Lottie
                            animationData={successAnim}
                            loop={false}
                            style={{ width: 250, height: 250, margin: "0px" }}
                        />

                    <Button label="Close & refresh" icon="pi pi-times" rounded severity="primary" onClick={() => {setSuccessVisible(false); fetchAutomations();}}/>
                </div>
            </Dialog>

            <Dialog
                header="Error"
                visible={failVisible}
                style={{ width: "40vw" }}
                onHide={() => setFailVisible(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <Lottie
                            animationData={failAnim}
                            loop={false}
                            style={{ width: 150, height: 150, margin: "0px" }}
                        />
                        <h3 style={{color:"#6e6e6eff"}}>{failMessage}</h3>
                    <Button label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setFailVisible(false)}/>
                </div>
            </Dialog>
        
        <div>
            <Suspense fallback={
                <div className={classes["loadingSpinner-container"]}>
                    <Oval stroke="var(--Primary-Color)" height={200} width={100} speed={1.5} />
                </div>
            }>
                <Await resolve={Promise.all([IFTTTRules, schedules, holidaymode, siteAccessRestrictions, advRules])}>
                    {([loadedSiteRules, loadedSiteSchedules, loadedHolidaymode, loadedSiteAccessRestrictions, loadedAdvRules]) =>
                        <AutomationsGrid 
                            DeviceRules={loadedSiteRules} 
                            siteSchedules={loadedSiteSchedules} 
                            siteHolidayModes={loadedHolidaymode} 
                            OutPutsPinNames={OutPutsPinNames} 
                            InputsPinNames={InputsPinNames} 
                            allListOptionsArray={allListOptionsArray} 
                            HandleSelectAutomation={HandleSelectAutomation} 
                            fetchAutomations={fetchAutomations} 
                            numInput={numInput} 
                            smartLocks={smartLocks} 
                            updateRemainRules={updateRemainRules} 
                            siteAccessRestrictions={loadedSiteAccessRestrictions} 
                            advRules={loadedAdvRules}
                        />
                    }
                </Await>
            </Suspense>
            
            {showAutomation == 5 && <CreateRule allListOptionsArray={remainingrules || allListOptionsArray} OutPutsPinNames={OutPutsPinNames} setShowAutomation={setShowAutomation} fetchAutomations={fetchAutomations} firmware={firmware} smartLocks={smartLocks} setSuccessVisible={setSuccessVisible} setFailVisible={setFailVisible} siteType={siteType} advanced={true} />}

            {showAutomation == 2 && <CreateRule allListOptionsArray={remainingrules || allListOptionsArray} OutPutsPinNames={OutPutsPinNames} setShowAutomation={setShowAutomation} fetchAutomations={fetchAutomations} firmware={firmware} smartLocks={smartLocks} setSuccessVisible={setSuccessVisible} setFailVisible={setFailVisible} siteType={siteType} />}
            {(showAutomation == 0 || showAutomation == 1) && < CreateSchedule OutPutOptions={OutPutsPinNames} isReminder={showAutomation} setShowAutomation={setShowAutomation} fetchAutomations={fetchAutomations} />}

            {showAutomation === 3 && <CreateHolidayMode OutPutsPinNames={OutPutsPinNames} setShowAutomation={setShowAutomation} smartLocks={smartLocks} fetchAutomations={fetchAutomations} />}
            {showAutomation === 4 && <CreateAccessRestriction fetchAutomations={fetchAutomations}/>}
        </div>
        </>
    )
}

export default React.memo(Automations);
